module.exports = __webpack_public_path__ + "media/slipper-sound-short.8d279880.mp3";